import { NbPasswordIdentityServer4AuthStrategy } from './../services/identityserver4-token-strategy';
import { HttpClient } from '@angular/common/http';
import {  Component } from '@angular/core';
import {  NbTokenService } from '@nebular/auth';


@Component({
  selector: 'ngx-logout', template: ' ',
})
export class LogoutComponent   {
  constructor(http: HttpClient, tokenService: NbTokenService, is4Service: NbPasswordIdentityServer4AuthStrategy ) {
    tokenService.get().subscribe(t => {
      let url = is4Service.getOption(`baseEndpoint`) + is4Service.getOption(`logout.endpoint`);

      url += '?id_token_hint=' + t;

      tokenService.clear().subscribe((success) => {
        http.get(url,  {responseType: 'text'}).subscribe( r => {
          window.location.href = is4Service.getOption(`logout.redirect.success`);
        }, error => {
          // console.log(error);
          window.location.href = is4Service.getOption(`logout.redirect.success`);
        });
      });
    });

  }
}
